import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import EditIcon from '@mui/icons-material/Edit';
import { Avatar, Badge, ListItemAvatar } from '@material-ui/core';
import { Icon } from '@iconify/react';

import ChatWindowMini from './ChatWindowMiniFacebook';
import { useDispatch, useSelector } from '../../redux/store';
import { getConversation as getConversationZalo } from '../../redux/slices/conversationZalo';
import { getConversation as getConversationFacebook } from '../../redux/slices/conversationFacebook';
import ChatWindowMiniZalo from './ChatWindowMiniZalo';
import ChatWindowMiniFacebook from './ChatWindowMiniFacebook';
import { removeContactEvent } from '../../redux/slices/chat';
import { objectID } from '../../utils/objectID';

export default function ListMessageBubble() {
    const [open, setOpen] = useState(true); // Set the initial state of the SpeedDial to open
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const [openWindowZalo, setOpenWindowZalo] = useState(false);
    const [openWindowFacebook, setOpenWindowFacebook] = useState(false);
    const [infoToChat, setInfoToChat] = useState({});
    const { contacts, contactFromEvents } = useSelector(state => state.chat);
    const dispatch = useDispatch();
    console.log(contacts)
    // const listAvatar = (info) => {

    //     const { channel } = info;
    //     if (channel === "zalo") {
    //         const urlImage = info.oa_id === info.from_id ? info.to_avatar : info.from_avatar;
    //         const name = info.oa_id === info.from_id ? info.to_display_name : info.from_display_name;
    //         const message_id = info.message_id;
    //         return (
    //             <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} onClick={() => handleClickToQuickChat(urlImage, name, message_id, info)}>
    //                 <Badge badgeContent={2} color="error">
    //                     <Avatar src={urlImage} alt={name} />
    //                 </Badge>
    //             </Box>
    //         );
    //     }
    //     if (channel === "facebook") {
    //         const urlImage = info.oa_id === info.from_id ? info.to_avatar : info.from_avatar;
    //         const name = info.oa_id === info.from_id ? info.to_display_name : info.from_display_name;
    //         const message_id = info.message_id;
    //         return (
    //             <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} onClick={() => handleClickToQuickChat(urlImage, name, message_id, info)}>
    //                 <Badge badgeContent={2} color="error">
    //                     <Avatar src={urlImage} alt={name} />
    //                 </Badge>
    //             </Box>
    //         );
    //     }

    // };
    const handleEventSelectedContact = (info) => {
        if (info.channel === 'facebook') {
            handleClickToQuickChatFacebook(info);
        }
        if (info.channel === "zalo") {
            handleClickToQuickChatZalo(info);
        }
    }
    useEffect(() => {
        handleOpen();
        handleEventSelectedContact(contactFromEvents)
    }, [contactFromEvents]);
    const handleClickToQuickChatZalo = (info) => {
        const urlImage = info.oa_id === info.from_id ? info.to_avatar : info.from_avatar;
        const name = info.oa_id === info.from_id ? info.to_display_name : info.from_display_name;
        const name_oa = info.oa_id === info.from_id ? info.from_display_name : info.to_display_name;
        const message_id = info.message_id;
        setOpenWindowZalo(true);
        setOpenWindowFacebook(false);
        const params = {
            app_id: info.app_id,
            oa_id: info.oa_id,
            uid: info.oa_id === info.from_id ? info.to_id : info.from_id,
            avatar_user: info.oa_id === info.from_id ? info.to_avatar : info.from_avatar,
            display_name: info.oa_id === info.from_id ? info.to_display_name : info.from_display_name,
            page: 1,
            name_oa: name_oa,
            assign_by: info?.assign_by_name,
            avatar_oa: info.oa_id === info.from_id ? info.from_avatar : info.to_avatar,
        }
        setInfoToChat({ urlImage, name, message_id, name_oa });
        dispatch(getConversationZalo(params));
    }
    const handleClickToQuickChatFacebook = (info) => {
        const urlImage = info.page_id === info.from_id ? info.to_avatar : info.from_avatar;
        const name = info.page_id === info.from_id ? info.to_display_name : info.from_display_name;
        const page_name = info.page_id === info.from_id ? info.from_display_name : info.to_display_name;
        const message_id = info.message_id;
        const { from_id, to_id, from_avatar, to_avatar, from_display_name, to_display_name, page_id, _id, assign_by_name, tag, color_tag } = info;
        const item = {
            id_conversation: objectID(_id),
            page_id: page_id,
            assign_by: assign_by_name,
            tag: tag,
            color_tag: color_tag,
            avatar_page: from_id === page_id ? from_avatar : to_avatar,
            name_page: from_id === page_id ? from_display_name : to_display_name,
            user_id: from_id === page_id ? to_id : from_id,
            avatar_user: from_id === page_id ? to_avatar : from_avatar,
            display_name: from_id === page_id ? to_display_name : from_display_name,
        }
        dispatch(
            getConversationFacebook(item));
        setOpenWindowFacebook(true);
        setOpenWindowZalo(false);
        setInfoToChat({ urlImage, name, message_id, page_name });

    }
    const handleCloseWindowChat = (uid, type) => {
        if (type === "zalo") {
            setOpenWindowZalo(false);
        }
        if (type === "facebook") {
            setOpenWindowFacebook(false);
        }
        dispatch(removeContactEvent({ uid, type }));
    }
    return (
        <Box sx={{ flexGrow: 1 }}>
            <SpeedDial
                ariaLabel="Mini Chat"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon openIcon={<EditIcon />} icon={<Icon icon="jam:messages-alt" width={28} height={28} />} />}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
            >
                {contacts.map((info, index) => {
                    const uniqueKey = info.message_id || index;
                    if (info.channel === "facebook") {
                        const urlImage = info.page_id === info.from_id ? info.to_avatar : info.from_avatar;
                        const name = info.page_id === info.from_id ? info.to_display_name : info.from_display_name;
                        return (
                            <SpeedDialAction
                                key={uniqueKey}
                                icon={
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} onClick={() => handleClickToQuickChatFacebook(info)}>
                                        <Badge
                                            invisible={!info?.is_read ? true : false}
                                            variant='dot'
                                            badgeContent={"*"}
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            color="error">
                                            <Avatar src={urlImage} alt={name} />
                                        </Badge>
                                    </Box>
                                }
                                tooltipTitle={info.name}
                            />
                        )
                    }
                    if (info.channel === "zalo") {
                        const urlImage = info.oa_id === info.from_id ? info.to_avatar : info.from_avatar;
                        const name = info.oa_id === info.from_id ? info.to_display_name : info.from_display_name;
                        return (
                            <SpeedDialAction
                                key={uniqueKey}
                                icon={
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} onClick={() => handleClickToQuickChatZalo(info)}>
                                        <Badge
                                            invisible={!info?.is_read ? true : false}
                                            variant='dot'
                                            badgeContent={"*"}
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            color="error">
                                            <Avatar src={urlImage} alt={name} />
                                        </Badge>
                                    </Box>
                                }
                                tooltipTitle={info.name}
                            />
                        )
                    }
                }
                )}
            </SpeedDial>
            {openWindowZalo && <ChatWindowMiniZalo isOpenWindowZalo={openWindowZalo} onMinimizeWindowZalo={() => setOpenWindowZalo(false)} onCloseWindowChat={handleCloseWindowChat} infoToChat={infoToChat} />}
            {openWindowFacebook && <ChatWindowMiniFacebook isOpenWindowFacebook={openWindowFacebook} onMinimizeWindowFacebook={() => setOpenWindowFacebook(false)} infoToChat={infoToChat} onCloseWindowChat={handleCloseWindowChat} />}
        </Box>
    );
}